"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EditSendersAndDomains_1 = require("./components/EditSendersAndDomains");
exports.EditSendersAndDomains = EditSendersAndDomains_1.EditSendersAndDomains;
var isEmailAddress_1 = require("./utils/isEmailAddress");
exports.isEmailAddress = isEmailAddress_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-mail-option-common/lib/index.js
// module id = 2939
// module chunks = 2